import { IconButton } from "@mui/material";
import { CompareArrowsIcon } from "@ui-icons";
import { useSwapGroups } from "../../hooks/useSwapGroups";

const ComparativeAnalysisGroupsSwapBtn = () => {
  const swapGroups = useSwapGroups();

  return (
    <IconButton
      onClick={swapGroups}
      className="p-2 rounded-full hover:bg-background-default hover:rotate-180 transition-all! ease-in-out duration-300"
      title="Swap groups"
      data-test-id="compare-runs--swap-groups-btn"
      data-ph-capture-attribute-action="swap_compare_groups"
    >
      <CompareArrowsIcon fontSize="medium" />
    </IconButton>
  );
};

export default ComparativeAnalysisGroupsSwapBtn;
